import { Component, OnInit } from '@angular/core';
import { AccountService } from './account.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { Severity, Status } from '../../constants/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FinanceSetupService } from '../finance-setup.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ObjectNames } from '../../constants/constants';
import { AppMainService } from 'src/app/app-main.service';
import { IFinanceAccount } from 'src/app/finance/models/finance-account.model';
import { AddEditDialogType } from 'src/app/finance/constants/constants';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  accountForm: FormGroup;
  allAccounts = [];
  accountTypes = [];
  chartGroupsData = [];
  parentAccountType = [];
  displayAddEditFinanceAccount: boolean = false;
  addEditChartHeader: string;
  isAddAccount: boolean = false;
  parentType: boolean = false;
  childType: boolean = false;
  displayAccountAvailability: boolean = false;
  associatedProducts: string;
  accountConstants = ObjectNames;
  disabledGroupForSubChild: boolean = false;
  addEditDialogType = 'ADD';
  editAccountData;
  isAscending = 'true';

  constructor(private accountService: AccountService, private confirmationService: ConfirmationService,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe, private fb: FormBuilder,
    private financeService: FinanceSetupService, private app: AppMainComponent, private appMainService: AppMainService) { }

  ngOnInit(): void {
    this.financeService.getAccount().subscribe(account => {
      if (account) {
        this.showAddAccount();
      }
    })
    this.loadAccountList();
  }

  loadAccountList() {
    this.appMainService.isShowSpinner("loadaccounts");
    this.accountService.fetchAllAccounts(this.isAscending).subscribe((accounts) => {
      this.appMainService.isHideSpinner("loadaccounts");
      this.allAccounts = accounts;
    });
  }

  checkAccount(parent, child, subChild?) {
    const deleteId = (subChild ? subChild.id : child.id)
    this.accountService.checkAccount(deleteId).subscribe((check) => {
      if (check.item1) {
        this.displayAccountAvailability = true;
        this.associatedProducts = check.item2;
      } else {
        this.deleteAccount(parent, child, subChild);
      }
    })
  }

  deleteAccount(parent, child, subChild?) {
    const deleteId = (subChild ? subChild.id : child.id)
    this.confirmationService.confirm({
      message: 'Do you want to delete this Account?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.accountService
        .deleteAccount(deleteId)
        .subscribe({
            next: (response) => {
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(
                        Severity.Success
                    ),
                    detail: "Deleted Successfully...",
                });
                this.loadAccountList();
            },
            error: (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(
                        Severity.Error
                    ),
                    detail: "Error occurred while deleting data...",
                });
            }
        });
        // this.accountService.deleteAccount(deleteId).then(() => {
        //   this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
        //   if (subChild) {
        //     const index = child.childAccounts.indexOf(subChild);
        //     child.childAccounts.splice(index, 1);
        //   } else {
        //     const index = parent.childAccounts.indexOf(child);
        //     parent.childAccounts.splice(index, 1);
        //   }
        //   this.loadAccountList();
        // }).catch(() => {
        //   this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        // });
      },
      reject: () => {
      }
    });
  }

  showAddAccount() {
    this.addEditDialogType = AddEditDialogType.Add;
    this.addEditChartHeader = ObjectNames.AddAccountTitle;
    this.displayAddEditFinanceAccount = true;
  }

  showEditAccount(parent?, child?, sub?) {
    this.addEditDialogType = AddEditDialogType.Edit;
    this.addEditChartHeader = ObjectNames.EidtAccountTitle;
    this.displayAddEditFinanceAccount = true;
    this.editAccountData = {
      parent: parent,
      child: child,
      sub: sub,
    };
  }

  updateAccount(event, data) {
    if (event && typeof event.stopPropagation === 'function') {
    event.stopPropagation();
    }
    const obj: IFinanceAccount = {
      id: data?.id,
      createdSource: data?.createdSource,
      updatedSource: this.app.userIP,
      createdBy: data?.createdBy,
      updatedBy: this.app.user.userId,
      createdDate: data?.createdDate,
      updatedDate: this.app._saveDateTimeWithZone(new Date()),
      organizationId: data?.organizationId,
      name: data?.name,
      accountTypeId: data?.accountTypeId,
      accountType: null,
      subAccountTypeId: data?.subAccountTypeId,
      subAccountType: null,
      parentFinancialAccountId: data?.parentFinancialAccountId,
      financialAccountNumber: data?.financialAccountNumber,
      financialStatementId: data?.financialStatementId,
      description: data?.description,
      qbdAccountMap: data?.qbdAccountMap,
      qboAccountMap: data?.qboAccountMap,
      qboAccountMapId: data?.qboAccountMapId,
      statusId: data?.statusId,
      objectId: data?.objectId,
      isDefault: data?.isDefault,
      isDebit: data?.isDebit,
      isBank: data?.isBank,
      isCreditCard: data?.isCreditCard,
      reconcileEnabled: data?.reconcileEnabled,
      displayAccountNumber: data?.displayAccountNumber,
      displayNumber: data?.displayNumber,
      displayOperator: data?.displayOperator
    };
    this.accountService.editAccount(obj).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: Severity.Success,
          summary: this.titlecasePipe.transform(Severity.Success),
          detail: "Account Updated successfully...",
        });
        this.loadAccountList();
      },
      error: (error) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    });
  }

  onCancelAccount() {
    this.addEditDialogType = "";
    this.displayAddEditFinanceAccount = false;
  }

  onSuccessfullAccountAddEdit(e) {
    this.addEditDialogType = "";
    this.displayAddEditFinanceAccount = false;
    this.loadAccountList();
  }

}
